import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-auth-template',
  template: `
    <div class="container grid grid-cols-1 gap-20 py-20 lg:grid-cols-2">
      <div class="col-span-1">
        <div class="text-center">
          <img
            class="mx-auto w-32"
            src="/assets/img/icon-secondary.svg"
            alt="Connexion"
            title="Connexion"
          />
          <h1 class="pt-6">{{ title }}</h1>
          <div class="pb-6 pt-2">Espace réservé aux hôtes.</div>
        </div>
        <ng-content></ng-content>
      </div>
      <div class="col-span-1 hidden justify-end lg:flex">
        <img
          ngSrc="auth.png"
          priority
          width="574"
          height="806"
          sizes="33vw"
          alt="Connexion"
          title="Connexion"
        />
      </div>
    </div>
  `,
  standalone: false,
})
export class AuthTemplateComponent {
  @Input() title: string;
}
